/** Custom properties Plausible accepts on an event. */
export type PlausibleEventProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    /** Bound by the tracker's `init()` (plausible-script.tsx), and only where it loads. */
    plausible?: (event: string, options?: { props?: PlausibleEventProps }) => void;
  }
}

/**
 * Sends a Plausible custom event, or does nothing where the tracker has not
 * loaded: a tenant with tracking off, a preview domain, the server, or before
 * the tracker's dynamic import has run.
 *
 * Send every event through here. A bare `plausible?.()` with nothing bound is
 * a ReferenceError, not a no-op: Buy Now threw one on every click that way.
 */
export function trackPlausibleEvent(event: string, props?: PlausibleEventProps): void {
  if (typeof window === 'undefined') return;
  if (props) {
    window.plausible?.(event, { props });
  } else {
    window.plausible?.(event);
  }
}
